// Configs
import apiConfig from './api.config';
import googleConfig from './google.config';
import metaConfig from './meta.config';

export const config = {
  api: apiConfig,
  google: googleConfig,
  meta: metaConfig,
};

export default config;
